import {
  Flexbox, Form, ListManager, ManualPaginator,
} from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import reports from '@/services/api/reports'
import PropTypes from 'prop-types'
import React, { useState } from 'react'

export default function FairsList({ onChange, selectedId }) {
  const [page, setPage] = useState(1)
  const [title, setTitle] = useState('')
  const [titleInput, setTitleInput] = useState('')
  const { data, loading, error } = useAxiosRequest(
    reports.adoptionsListFairs, { page, take: 5, q: { fairTitle: title } },
  )

  function search() {
    setTitle(titleInput.trim())
    setPage(1)
  }

  return (
    <>
      <Flexbox.Columns>
        <Flexbox.Column>
          <Form.Input
            value={titleInput}
            onChange={(event) => setTitleInput(event.target.value)}
            className="input-sm"
            placeholder="Buscar feira pelo título"
            autoComplete="off"
          />
        </Flexbox.Column>
        <Flexbox.Column className="col-auto">
          <button
            type="button"
            className="btn btn-primary btn-sm btn-action"
            onClick={search}
            aria-label="Buscar feira"
          >
            <i className="fas fa-search" />
          </button>
        </Flexbox.Column>
      </Flexbox.Columns>

      <ListManager loading={loading} count={data?.count || 0} error={error}>
        {data && (
          <>
            <table className="table table-striped table-hover text-small mt-2">
              <thead>
                <tr>
                  <th>Feira</th>
                  <th width="1" className="text-right">Selecionar</th>
                </tr>
              </thead>
              <tbody>
                {data.rows.map((fair) => (
                  <tr key={fair.id}>
                    <td>{fair.title}</td>
                    <td className="text-right">
                      <button
                        type="button"
                        className={`btn btn-action btn-sm ${selectedId === fair.id ? 'btn-success' : 'btn-primary'}`}
                        onClick={() => onChange(fair)}
                        aria-label={`Selecionar ${fair.title}`}
                      >
                        <i className="fas fa-check" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <Flexbox.Columns className="align-center mt-2">
              <Flexbox.Column>
                <small>
                  Registros: <b>{data.count}</b>
                </small>
              </Flexbox.Column>
              <Flexbox.Column className="col-auto">
                <ManualPaginator paginatedList={data} setPage={setPage} />
              </Flexbox.Column>
            </Flexbox.Columns>
          </>
        )}
      </ListManager>
    </>
  )
}

FairsList.propTypes = {
  onChange: PropTypes.func.isRequired,
  selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

FairsList.defaultProps = {
  selectedId: '',
}
